import { render, staticRenderFns } from "./phoneCard.vue?vue&type=template&id=d7ea4ff2"
import script from "./phoneCard.vue?vue&type=script&lang=js"
export * from "./phoneCard.vue?vue&type=script&lang=js"
import style0 from "./phoneCard.vue?vue&type=style&index=0&id=d7ea4ff2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports